var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        ADD_TO_CART: 'api/v2/cart/add_item_to_shopping_cart',
        ADD_BULK_TO_CART: 'api/v2/cart/Add_Weight_Item_to_Cart',
        REMOVE_FROM_CART: 'api/v2/cart/Remove_item_from_cart',
        CLEAR_CART: 'api/v2/cart/clear',
        LOAD_USER_CART: 'api/v2/cart/active_cart',
        LOAD_CART_PAYMENT: 'api/v2/cart/cart_payment',
        LOAD_CART_DETAILS: 'api/v2/cart/active_cart_detail',
        EDIT_ITEM: 'api/v2/cart/edit_item_in_cart',
        APPLY_DISCOUNT: 'api/v2/discount/apply_selected_discount',
        ALLOTMENT: 'api/v2/cart/Cart_Allocation',
        REMOVE_APPLIED_DISCOUNT: 'api/v2/discount/delete_selected_discount',
        APPLIED_DISCOUNTS: 'api/v2/discount/get_discounts_applied',
        REMOVE_APPLIED_FEE_DONATION: 'api/v2/fee-donation/remove-fee-donation',
        APPLY_DISOCUNT_BY_CODE: 'api/v2/discount/apply-by-code',

        APPLY_LOYALTY_POINTS: 'api/v2/cart/Update_Loyalty_To_Transaction',

        NETA_AUTO_PRICE: 'api/v2/neta/Neta_Auto_Price',
        NETA_AUTO_DISCOUNT: 'api/v2/neta/Neta_Auto_Discount',

        LOAD_PRE_ORDERS: 'api/v2/cart/pre-order-listing',
        REMOVE_PRE_ORDER: 'api/v2/cart/RemovePreOrderItem',

        PRINT_RECEIPT: 'api/v2/print-jobs/print-receipt',

        CART_SUMMARY: 'api/v2/cart/cart-summary',

        LOAD_CART: 'api/v2/cart/load',

        CALC_CART_TOTAL: 'api/v2/cart/calculate-cart-total',

        REMOVE_SPRINGBIG_REDEMPTION: 'api/Springbig/remove-redemption',

        LOAD_CART_DISPLAY: 'api/v2/cart/get-cart-display',
        CLEAR_CART_DISPLAY: 'api/v2/cart/clear-cart-display',
        LOAD_REMOTE_PAY_STATUS: 'api/remotepay/load-remote-pay-status',
    },

    actions: keyMirror({
        USER_CART_LOADED: null,
        ALLOTMENT_LOADED: null,
        PRE_ORDERS_LOADED: null,
        START_LOAD: null,
        END_LOAD: null,
        REMOTE_PAY_STATUS_LOADED: null,
        CART_TOTAL_CALCULATED: null,
        CART_TOTAL_CALCULATING: null,
        CART_TOTAL_FAILED: null,
    }),

    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
    }),
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/PosCartConstants.jsx